module.exports = __webpack_public_path__ + "img/bg.221b9905.png";